import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { Paths } from "../../../../Paths";
import { useBoolean } from "../../../hooks/common/useBoolean";
import ContactSupport from "../../common/icons/ContactSupportIcon";
import { FAQIcon } from "../../common/icons/FAQIcon";
import HelpIcon from "../../common/icons/HelpIcon";
import { useNavigate } from "react-router-dom";

export default function HelpButton() {

    const navigate = useNavigate();

    const [isOpen, , closeMenu, toggle] = useBoolean();

    const handleInquiryClicked = () => {
        navigate(Paths.inquiry);
        closeMenu();
    };

    const handleFAQClicked = () => {
        navigate(`${Paths.faq}${Paths.list}`);
        closeMenu();
    };


    const renderMenus = () => {
        if (!isOpen) return null;

        return (
            <div className={"drop_down__menus"}>
                <div className={"menu"} onClick={handleFAQClicked}>
                    <div className={"icon"}><FAQIcon /></div>
                    <div>よくあるご質問</div>
                </div>
                <div className={"menu"} onClick={handleInquiryClicked}>
                    <div className={"icon"}><ContactSupport /></div>
                    お問い合わせ
                </div>
            </div>
        );
    };

    return (
        <OutsideClickHandler onOutsideClick={closeMenu}>
            <button className={"help_button"} onClick={toggle}>
                <HelpIcon/>
                <div>ヘルプ</div>
            </button>
            {renderMenus()}
        </OutsideClickHandler>
    );
}
